import React, {
  useEffect,
} from 'react';
import {
  useForm,
} from 'react-hook-form';
import Controller from 'core/components/FormController';
import {
  appointmentsEventChannel,
  billingEventChannel,
} from 'pages/Dashboard/services/eventChannels';
import {
  useModifyAppointmentPaymentType,
} from 'pages/Dashboard/pages/Appointments/pages/List/hooks';
import OutOfPocketCheckbox from 'views/EMR/components/OutOfPocketCheckbox';
import {
  AppointmentOverviewDTO,
} from 'dtos';

type Form = {
  isOutOfPocket: boolean;
};

export default function OutOfPocketRow({
  encounterId,
  isOutOfPocket,
  isShiftedToPatient,
}: AppointmentOverviewDTO) {
  const {
    mutateAsync: modifyAppointmentPaymentType,
  } = useModifyAppointmentPaymentType();

  const { control, reset } = useForm<Form>({
    mode: 'onChange',
    defaultValues: { isOutOfPocket },
  });

  useEffect(() => {
    reset({ isOutOfPocket });
  }, [isOutOfPocket]);

  const updateData = async ({ isOutOfPocket: _isOutOfPocket }: Form) => {
    try {
      await modifyAppointmentPaymentType({
        isOutOfPocket: _isOutOfPocket,
        insuranceId: null,
        encounterId,
      });

      billingEventChannel.emit('onChargesInfoChange', {
        encounterId,
        isOutOfPocket: _isOutOfPocket,
        id: 0,
      });
      appointmentsEventChannel.emit('onEventUpdated', encounterId);
    } catch (e) {
      console.error(e);
      reset({ isOutOfPocket });
    }
  };

  return (
    <div className="p-2 w-fit">
      <Controller
        name="isOutOfPocket"
        control={control}
        render={({ field }) => (
          <OutOfPocketCheckbox
            {...field}
            disabled={isShiftedToPatient ?? false}
            shiftedToPatient={isShiftedToPatient ?? false}
            onChange={(checked) => {
              field.onChange(checked);
              updateData({ isOutOfPocket: checked });
            }}
            encounterId={encounterId!}
          />
        )}
      />
    </div>
  );
}
